(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  // 目录：从正文 h2 生成锚点；不足 2 个标题就不显示。滚动时高亮当前段。
  document.querySelectorAll('.xp-article').forEach(function (root) {
    var body = root.querySelector('[data-article-body]');
    var toc = root.querySelector('[data-article-toc]');
    var list = root.querySelector('[data-article-toc-list]');
    var layout = root.querySelector('.xp-article__layout');
    if (!body || !toc || !list) return;
    var heads = Array.prototype.slice.call(body.querySelectorAll('h2'));
    if (heads.length < 2) { if (layout) layout.classList.add('xp-article__layout--no-toc'); return; }
    var used = {};
    heads.forEach(function (h, i) {
      var slug = (h.textContent || '').trim().toLowerCase().replace(/[^\w一-龥]+/g, '-').replace(/^-+|-+$/g, '') || 'section-' + (i + 1);
      if (used[slug]) slug += '-' + (i + 1);
      used[slug] = true;
      if (!h.id) h.id = slug;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.hidden = false;
    if ('IntersectionObserver' in window) {
      var links = list.querySelectorAll('a');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (a) { a.removeAttribute('aria-current'); });
          var a = list.querySelector('a[href="#' + e.target.id + '"]');
          if (a) a.setAttribute('aria-current', 'true');
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      heads.forEach(function (h) { io.observe(h); });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '.xp-recs[data-url]';
    var hasIO = 'IntersectionObserver' in window;

    // 注入后的 .xp-reveal 不在 base.js 的观察名单里，这里用同一套 is-pending / is-in 类补上（样式在 critical.css）
    var revealIO = hasIO
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.remove('is-pending');
            entry.target.classList.add('is-in');
            revealIO.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -8% 0px' })
      : null;

    function reveal(box) {
      if (!revealIO) return;
      box.querySelectorAll('.xp-reveal').forEach(function (el) {
        if (el.getBoundingClientRect().top > window.innerHeight) {
          el.classList.add('is-pending');
          revealIO.observe(el);
        }
      });
    }

    function load(box) {
      if (box.dataset.state) return;
      box.dataset.state = 'loading';
      fetch(box.dataset.url)
        .then(function (response) {
          return response.ok ? response.text() : Promise.reject(new Error(String(response.status)));
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.getElementById(box.id);
          if (!fresh || !fresh.innerHTML.trim()) {
            box.dataset.state = 'empty';
            return;
          }
          box.innerHTML = fresh.innerHTML;
          // 标题以整页渲染时算好的 data-heading 为准；没有标题就把 h2 和 aria-labelledby 一起拿掉，不留空 h2
          var heading = box.querySelector('[data-recs-heading]');
          if (heading) {
            if (box.dataset.heading) {
              heading.textContent = box.dataset.heading;
            } else {
              var labelled = box.querySelector('[aria-labelledby="' + heading.id + '"]');
              if (labelled) labelled.removeAttribute('aria-labelledby');
              heading.remove();
            }
          }
          box.dataset.state = 'loaded';
          reveal(box);
        })
        .catch(function () {
          box.dataset.state = 'error';
        });
    }

    function init(root) {
      (root || document).querySelectorAll(SELECTOR).forEach(function (box) {
        if (box.dataset.state) return;
        if (!hasIO) {
          load(box);
          return;
        }
        // 容器进到视口下方 400px 内才请求，避免和首屏抢带宽
        var io = new IntersectionObserver(function (entries) {
          var near = entries.some(function (entry) { return entry.isIntersecting; });
          if (!near) return;
          io.disconnect();
          load(box);
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(box);
      });
    }

    init();
    // 主题编辑器里重渲染本段后重新拉一次
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /* 产品页：变体切换 / 图库 / sticky 加购条 / 加购事件。无 Liquid，文案从 data-t-* 读。 */
  if (!customElements.get('xp-product')) {
    customElements.define(
      'xp-product',
      class XpProduct extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('[data-product-form]');
          this.idInput = this.querySelector('[data-variant-id]');
          this.qtyInput = this.querySelector('[data-quantity]');
          this.atc = this.querySelector('[data-atc]');
          this.atcLabel = this.querySelector('[data-atc-label]');
          this.priceEl = this.querySelector('[data-price]');
          this.msg = this.querySelector('[data-msg]');
          this.main = this.querySelector('[data-main]');
          this.imgs = this.main ? Array.prototype.slice.call(this.main.querySelectorAll('img')) : [];
          /* 初始大图不一定是第 0 张（变体带图时是那张），从 .is-current 反推，别写死 0 */
          this.currentIndex = 0;
          for (var ci = 0; ci < this.imgs.length; ci++) {
            if (this.imgs[ci].classList.contains('is-current')) {
              this.currentIndex = ci;
              break;
            }
          }
          this.imgCounter = this.querySelector('[data-img-i]');
          this.comboBox = this.querySelector('[data-combo]');
          this.comboText = this.querySelector('[data-combo-text]');
          this.comboFix = this.querySelector('[data-combo-fix]');
          this.lastPick = -1;
          this.suggestion = null;
          this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));
          this.thumbStrip = this.querySelector('[data-thumbstrip]');
          this.thumbWrap = this.querySelector('[data-thumbwrap]');
          this.groups = Array.prototype.slice.call(this.querySelectorAll('[data-option]'));
          this.buy = this.querySelector('[data-buy]');
          this.bar = this.querySelector('[data-bar]');
          this.barImg = this.querySelector('[data-bar-img]');
          this.barVariant = this.querySelector('[data-bar-variant]');
          this.barPrice = this.querySelector('[data-bar-price]');
          this.barBtn = this.querySelector('[data-bar-atc]');

          var json = this.querySelector('[data-variants]');
          try {
            this.variants = json ? JSON.parse(json.textContent) : [];
          } catch (e) {
            this.variants = [];
          }

          this.pending = false;
          this.timer = null;
          if (this.thumbStrip) {
            this._onThumbSync = this.syncThumbNav.bind(this);
            this.thumbStrip.addEventListener('scroll', this._onThumbSync, { passive: true });
            window.addEventListener('resize', this._onThumbSync);
            if (window.ResizeObserver) {
              this.thumbRO = new ResizeObserver(this._onThumbSync);
              this.thumbRO.observe(this.thumbStrip);
            }
            /* 缩略图是 lazy 的，字体/图片到位前宽度算不准，落定后再补一次 */
            this.syncThumbNav();
            if (document.fonts && document.fonts.ready) document.fonts.ready.then(this._onThumbSync);
            window.addEventListener('load', this._onThumbSync, { once: true });
          }
          this.retiredNotice = this.querySelector('[data-retired-option]');
          var requested = new URL(window.location.href).searchParams.get('variant');
          this.needsReselection = !!requested && !this.variants.some(function(v) { return String(v.id) === requested; });
          if (this.needsReselection) {
            this.groups.forEach(function(g) {
              g.querySelectorAll('button[data-value]').forEach(function(b) { b.setAttribute('aria-pressed', 'false'); });
              var label = g.querySelector('[data-option-value]');
              if (label) label.textContent = 'Please select';
            });
            if (this.retiredNotice) this.retiredNotice.hidden = false;
            var single = this.querySelector('[data-confirm-single]');
            if (single) single.hidden = this.groups.length > 0 || !this.variants.some(function(v) { return v.available; });
          }
          this.current = this.needsReselection ? null : this.find(this.selected());
          this.apply(this.current, this.selected());
          this.markAvailability(this.selected());
          this.syncQty();
          if (this.qtyInput) {
            this._onQtyInput = this.syncQty.bind(this);
            this.qtyInput.addEventListener('change', this._onQtyInput);
            this.qtyInput.addEventListener('blur', this._onQtyInput);
          }

          this._onClick = this._onClick.bind(this);
          this._onPrefetch = this._onPrefetch.bind(this);
          this._onSubmit = this._onSubmit.bind(this);
          this._onCartUpdated = this._onCartUpdated.bind(this);
          this._onCartError = this._onCartError.bind(this);
          this._onFormAdding = this._onFormAdding.bind(this);
          this.addEventListener('click', this._onClick);
          /* 缩略图 hover / 聚焦时先把那张大图取回来，点下去就不会闪一下 */
          this.addEventListener('mouseover', this._onPrefetch);
          this.addEventListener('focusin', this._onPrefetch);
          /* 审计 #11：触屏上 mouseover 只比 click 早 2ms，等于没有预取（实测 430–500ms 纯灰块）。
             pointerdown / touchstart 在手指按下去那一刻就开始取图，能抢出几十到几百毫秒。 */
          this.addEventListener('pointerdown', this._onPrefetch);
          this.addEventListener('touchstart', this._onPrefetch, { passive: true });
          this.bindGallerySwipe();
          /* 相邻两张的预取等页面 load 完再做，别跟 LCP 主图抢带宽 */
          if (document.readyState === 'complete') {
            this._idlePrefetch();
          } else {
            this._onLoadPrefetch = this._idlePrefetch.bind(this);
            window.addEventListener('load', this._onLoadPrefetch, { once: true });
          }
          if (this.form) {
            this.form.addEventListener('submit', this._onSubmit);
            /* cart.js 自动拦截表单提交时在表单上派发这三个事件（detail.form / detail.message） */
            this.form.addEventListener('cart:adding', this._onFormAdding);
            this.form.addEventListener('cart:added', this._onCartUpdated);
            this.form.addEventListener('cart:error', this._onCartError);
          }
          document.addEventListener('cart:error', this._onCartError);

          /* sticky 条：观察对象是加购按钮本身，不是购买盒 —— 购买盒现在装着描述 / Product Size /
             规格，桌面端有 4000px 高，盯着它的话要滚到快见底才亮，等于这条 bar 不存在。
             审计 #9：判定也从"滚过表单"换成"真按钮不在视口里"。
             原来只有 boundingClientRect.top < 0（已经滚过按钮）才亮，实测手机上翻转点在
             scrollY=2100、而真按钮底边在 1931 —— 这条 bar 只在客户已经走过按钮之后才出现，
             对最需要它的前 2.7 屏完全无效。
             手机上再加一条：还没滚到按钮、但已经滚过 200px 就先给入口（真按钮一进视口自动收起，
             不会同屏出现两颗加购按钮）。桌面端 mobile=false，行为跟原来一致。 */
          this.stickyRef = this.atc || this.form || this.buy;
          if (this.bar && this.stickyRef) {
            this._onBarSync = this.queueBarSync.bind(this);
            window.addEventListener('scroll', this._onBarSync, { passive: true });
            window.addEventListener('resize', this._onBarSync);
            if ('IntersectionObserver' in window) {
              this.io = new IntersectionObserver(this._onBarSync, { threshold: 0 });
              this.io.observe(this.stickyRef);
            }
            this.syncBar();
          }
        }

        /* 滚动里每帧最多算一次，避免 scroll 上直接读 rect 抖动 */
        queueBarSync() {
          if (this._barRaf) return;
          var self = this;
          var tick = function () {
            self._barRaf = 0;
            self.syncBar();
          };
          if (window.requestAnimationFrame) this._barRaf = window.requestAnimationFrame(tick);
          else this._barRaf = setTimeout(tick, 16);
        }

        syncBar() {
          var bar = this.bar;
          var ref = this.stickyRef;
          if (!bar || !ref) return;
          var r = ref.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight || 0;
          var mobile = window.matchMedia ? window.matchMedia('(max-width: 959px)').matches : false;
          var y = window.pageYOffset || document.documentElement.scrollTop || 0;
          var on;
          if (r.bottom > 0 && r.top < vh) {
            on = false; /* 真按钮就在屏幕上：不跟它抢 */
          } else if (r.top < 0) {
            on = true; /* 已经滚过按钮 */
          } else {
            on = mobile && y > 200; /* 还没滚到按钮：手机上滚一屏内就给入口 */
          }
          if (on === this._barOn) return;
          this._barOn = on;
          bar.classList.toggle('is-show', on);
          bar.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (on) bar.removeAttribute('inert');
          else bar.setAttribute('inert', '');
        }

        disconnectedCallback() {
          this.removeEventListener('click', this._onClick);
          this.removeEventListener('mouseover', this._onPrefetch);
          this.removeEventListener('focusin', this._onPrefetch);
          this.removeEventListener('pointerdown', this._onPrefetch);
          this.removeEventListener('touchstart', this._onPrefetch);
          this.unbindGallerySwipe();
          if (this._onBarSync) {
            window.removeEventListener('scroll', this._onBarSync);
            window.removeEventListener('resize', this._onBarSync);
          }
          if (this._onLoadPrefetch) window.removeEventListener('load', this._onLoadPrefetch);
          clearTimeout(this._imgTimer);
          if (this.form) {
            this.form.removeEventListener('submit', this._onSubmit);
            this.form.removeEventListener('cart:adding', this._onFormAdding);
            this.form.removeEventListener('cart:added', this._onCartUpdated);
            this.form.removeEventListener('cart:error', this._onCartError);
          }
          document.removeEventListener('cart:error', this._onCartError);
          if (this._onThumbSync) {
            window.removeEventListener('resize', this._onThumbSync);
            if (this.thumbStrip) this.thumbStrip.removeEventListener('scroll', this._onThumbSync);
          }
          if (this.thumbRO) this.thumbRO.disconnect();
          if (this.io) this.io.disconnect();
          clearTimeout(this.timer);
        }

        /* Pointer Events work for touch, pen and mouse without double-firing
           touch/click handlers. Only a deliberate horizontal gesture changes a photo. */
        bindGallerySwipe() {
          if (!this.main || this.imgs.length < 2 || !window.PointerEvent) return;
          this._galleryListeners = [
            ['pointerdown', this.startGallerySwipe.bind(this)],
            ['pointermove', this.moveGallerySwipe.bind(this)],
            ['pointerup', this.endGallerySwipe.bind(this)],
            ['pointercancel', this.endGallerySwipe.bind(this)],
            ['lostpointercapture', this.endGallerySwipe.bind(this)],
            ['dragstart', function(e) { e.preventDefault(); }]
          ];
          this._galleryListeners.forEach(function(entry) {
            this.main.addEventListener(entry[0], entry[1]);
          }, this);
        }

        clearGallerySwipe() {
          var gesture = this._galleryGesture;
          this._galleryGesture = null;
          if (gesture && this.main.hasPointerCapture && this.main.hasPointerCapture(gesture.id)) {
            this.main.releasePointerCapture(gesture.id);
          }
        }

        unbindGallerySwipe() {
          this.clearGallerySwipe();
          (this._galleryListeners || []).forEach(function(entry) {
            this.main.removeEventListener(entry[0], entry[1]);
          }, this);
          this._galleryListeners = null;
        }

        startGallerySwipe(e) {
          if (!e.isPrimary) { this.clearGallerySwipe(); return; }
          if (e.button !== 0 || (window.visualViewport && window.visualViewport.scale > 1.01)) return;
          this._galleryGesture = {id:e.pointerId, x:e.clientX, y:e.clientY, index:this.currentIndex, horizontal:false};
          if (this.main.setPointerCapture) this.main.setPointerCapture(e.pointerId);
        }

        moveGallerySwipe(e) {
          var gesture = this._galleryGesture;
          if (!gesture || gesture.id !== e.pointerId) return;
          var dx = e.clientX - gesture.x;
          var dy = e.clientY - gesture.y;
          if (!gesture.horizontal) {
            if (Math.max(Math.abs(dx), Math.abs(dy)) < 10) return;
            if (Math.abs(dy) >= Math.abs(dx)) { this.clearGallerySwipe(); return; }
            if (Math.abs(dx) < Math.abs(dy) * 1.25) return;
            gesture.horizontal = true;
            this.hydrate(gesture.index + (dx < 0 ? 1 : -1));
          }
          if (e.cancelable) e.preventDefault();
        }

        endGallerySwipe(e) {
          var gesture = this._galleryGesture;
          if (!gesture || gesture.id !== e.pointerId) return;
          this.clearGallerySwipe();
          if (e.type !== 'pointerup' || gesture.index !== this.currentIndex) return;
          // Fast gestures may deliver no intermediate pointermove; validate the end position too.
          var dx = e.clientX - gesture.x;
          var dy = e.clientY - gesture.y;
          var threshold = Math.max(32, Math.min(60, this.main.clientWidth * 0.12));
          if (Math.abs(dx) < threshold || Math.abs(dx) < Math.abs(dy) * 1.25) return;
          this.show(gesture.index + (dx < 0 ? 1 : -1));
        }

        /* ---------- 事件 ---------- */
        _onClick(e) {
          var confirm = e.target.closest('[data-confirm-single]');
          if (confirm && this.contains(confirm)) {
            var available = this.variants.find(function(v) { return v.available; });
            if (available) { this.completeReselection(); this.apply(available, available.options); }
            return;
          }
          var navBtn = e.target.closest('[data-thumb-scroll]');
          if (navBtn) { this._onThumbScroll(parseInt(navBtn.dataset.thumbScroll, 10) || 1); return; }
          var thumb = e.target.closest('[data-thumb]');
          if (thumb && this.contains(thumb)) {
            this.show(parseInt(thumb.dataset.index, 10));
            return;
          }
          var fixBtn = e.target.closest('[data-combo-fix]');
          if (fixBtn && this.contains(fixBtn)) {
            this.selectVariant(this.suggestion);
            return;
          }
          var opt = e.target.closest('[data-option] button[data-value]');
          if (opt && this.contains(opt)) {
            this.pick(opt);
            return;
          }
          var qtyBtn = e.target.closest('[data-qty-step]');
          if (qtyBtn && this.contains(qtyBtn)) {
            this.stepQty(parseInt(qtyBtn.dataset.qtyStep, 10) || 1);
            return;
          }
          var codeBtn = e.target.closest('[data-copy-code]');
          if (codeBtn && this.contains(codeBtn)) {
            this.copyCode(codeBtn);
            return;
          }
          if (e.target.closest('[data-bar-atc]') && this.atc && !this.atc.disabled) {
            this.atc.click();
          }
        }

        /* 数量步进器：只改表单里那个 quantity input 的值，下限 1，减到 1 时把减号置灰。 */
        stepQty(delta) {
          if (!this.qtyInput) return;
          var n = parseInt(this.qtyInput.value, 10);
          if (isNaN(n) || n < 1) n = 1;
          n = n + delta;
          if (n < 1) n = 1;
          this.qtyInput.value = n;
          this.syncQty();
        }

        syncQty() {
          if (!this.qtyInput) return;
          var n = Math.floor(Number(this.qtyInput.value));
          if (!Number.isSafeInteger(n) || n < 1) n = 1;
          this.qtyInput.value = n;
          var minus = this.querySelector('[data-qty-step="-1"]');
          if (minus) minus.disabled = n <= 1;
          this.dispatchEvent(new CustomEvent('product:selection'));
        }

        /* 优惠码：点一下复制到剪贴板，1.6s 后恢复。文案在 Liquid 里，这里只切 class。 */
        copyCode(btn) {
          var code = btn.getAttribute('data-copy-code') || '';
          if (!code) return;
          var flash = function () {
            btn.classList.add('is-copied');
            clearTimeout(btn.jnCopyTimer);
            btn.jnCopyTimer = setTimeout(function () {
              btn.classList.remove('is-copied');
            }, 1600);
          };
          /* 剪贴板 API 在无 user activation / 无权限时会 reject，回退到 execCommand；
             两条路都失败就不给假反馈，码本身在页面上是可读文本，可以手抄。 */
          var legacy = function () {
            var ta = document.createElement('textarea');
            ta.value = code;
            ta.setAttribute('readonly', '');
            ta.style.position = 'fixed';
            ta.style.top = '0';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            var ok = false;
            try {
              ok = document.execCommand('copy');
            } catch (err) {
              ok = false;
            }
            document.body.removeChild(ta);
            if (ok) flash();
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(flash, legacy);
          } else {
            legacy();
          }
        }

        _onSubmit(e) {
          if (this.needsReselection || !this.current || !this.current.available) {
            e.preventDefault(); e.stopImmediatePropagation();
            if (this.needsReselection && this.retiredNotice) this.retiredNotice.scrollIntoView({block:'center', behavior:'smooth'});
            return;
          }
          /* 加速结账按钮（Shop Pay / PayPal / Google Pay，以及钱包不可用时 Shopify 退回的
             "Buy it now"）就在同一个 product 表单里，按下去也算这个表单的 submit。
             这条 submit 必须走 Shopify 自己的结账流程，不能被 cart.js 的 document 级拦截
             改写成 AJAX 加购——所以只 stopPropagation，不 preventDefault。 */
          var submitter = e.submitter || document.activeElement;
          if (submitter && submitter.closest && submitter.closest('.shopify-payment-button')) {
            e.stopPropagation();
            return;
          }
          if (!(window.XP && window.XP.cartReady)) return; /* cartReady 未设：不拦截，交给 cart.js 的 document 级拦截或原生提交 /cart/add */
          e.preventDefault();
          e.stopPropagation(); /* 别让 cart.js 的 document 级 submit 拦截再加一次 */
          if (this.pending || !this.current || !this.current.available) return;
          this.startPending();
          window.XP.emit('cart:add', {
            id: this.current.id,
            quantity: this.qtyInput ? parseInt(this.qtyInput.value, 10) || 1 : 1,
            sectionId: this.dataset.sectionId,
            form: this.form
          });
        }

        /* cart.js 拦截表单提交后派发（表单级）：进入 adding 态 */
        _onFormAdding() {
          this.startPending();
        }

        startPending() {
          this.pending = true;
          this.hideMsg();
          this.setAtc('adding');
          clearTimeout(this.timer);
          // Only a completed request may unlock ATC; a slow response can still add items.
        }

        _onCartUpdated() {
          if (!this.pending) return;
          this.pending = false;
          clearTimeout(this.timer);
          this.setAtc('added');
          var self = this;
          this.timer = setTimeout(function () {
            self.setAtc(self.stateFor(self.current));
          }, 1500);
        }

        _onCartError(e) {
          var errorForm = e && e.detail && e.detail.form;
          if (errorForm && errorForm !== this.form) return;
          if (!this.pending && errorForm !== this.form) return;
          this.pending = false;
          clearTimeout(this.timer);
          this.setAtc(this.stateFor(this.current));
          var m = e && e.detail && e.detail.message;
          if (m) this.showMsg(m);
        }

        /* ---------- 变体 ---------- */
        selected() {
          return this.groups.map(function (g) {
            var b = g.querySelector('button[aria-pressed="true"]');
            return b ? b.dataset.value : null;
          });
        }

        find(sel) {
          if (!this.variants.length) return null;
          if (!sel.length) return this.variants[0];
          for (var i = 0; i < this.variants.length; i++) {
            var v = this.variants[i];
            var ok = v.options.length === sel.length;
            for (var j = 0; ok && j < sel.length; j++) ok = v.options[j] === sel[j];
            if (ok) return v;
          }
          return null;
        }

        resolveVariant(sel, changedIndex) {
          var exact = this.find(sel);
          if (exact) return exact;
          return this.variants.filter(function(v) { return v.options[changedIndex] === sel[changedIndex]; }).sort(function(a,b) {
            var sa = a.options.reduce(function(n,x,i) { return n + (i !== changedIndex && x === sel[i] ? 1 : 0); },0);
            var sb = b.options.reduce(function(n,x,i) { return n + (i !== changedIndex && x === sel[i] ? 1 : 0); },0);
            return sb - sa || Number(b.available) - Number(a.available);
          })[0] || null;
        }
        applySelection(v) {
          this.groups.forEach(function(group,i) {
            group.querySelectorAll('button[data-value]').forEach(function(b) { b.setAttribute('aria-pressed',String(b.dataset.value === v.options[i])); });
            var label = group.querySelector('[data-option-value]');
            var picked=group.querySelector('button[aria-pressed="true"]');
            if (label) label.textContent = picked ? (picked.dataset.label || picked.dataset.value) : v.options[i];
          });
        }
        pick(btn) {
          var group = btn.closest('[data-option]');
          if (!group) return;
          Array.prototype.forEach.call(group.querySelectorAll('button[data-value]'), function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          var lab = group.querySelector('[data-option-value]');
          if (lab) lab.textContent = btn.dataset.label || btn.dataset.value;
          /* 记住客户刚动的是哪一组：组合配不出货时以"他刚选的那个值"为锚点给建议，
             绝不建议他改回刚点的那个（审计 #1）。 */
          var gi = parseInt(group.dataset.optionIndex, 10);
          this.lastPick = isNaN(gi) ? -1 : gi;
          var sel = this.selected();
          var resolved = this.needsReselection ? this.find(sel) : this.resolveVariant(sel, this.lastPick);
          if (this.needsReselection && resolved) this.completeReselection();
          if (resolved && !this.find(sel)) {
            var changed = resolved.options.filter(function(value, index) { return value !== sel[index]; });
            this.applySelection(resolved);
            sel = resolved.options.slice();
            this.apply(resolved, sel);
            this.showMsg('Updated the other option to ' + changed.join(' · ') + ' to match your selection.');
          } else { this.hideMsg(); this.apply(resolved, sel); }
          this.markAvailability(sel);
        }

        completeReselection() {
          this.needsReselection = false;
          if (this.retiredNotice) this.retiredNotice.hidden = true;
          document.documentElement.classList.remove('xp-retired-variant');
        }

        apply(v, sel) {
          this.current = v;
          this.dispatchEvent(new CustomEvent('product:selection'));
          if (!v) {
            if (this.idInput) { this.idInput.value = ''; this.idInput.disabled = true; }
            var unavailableDynamic = this.querySelector('.xp-pdp__dynamic');
            if (unavailableDynamic) unavailableDynamic.hidden = true;
            this.setAtc(this.pending ? 'adding' : 'unavailable');
            if (this.needsReselection) {
              if (this.atcLabel) this.atcLabel.textContent = 'Select options';
              if (this.barBtn) this.barBtn.textContent = 'Select options';
              this.hideCombo();
              return;
            }
            this.showCombo(sel || this.selected());
            return;
          }
          this.hideCombo();
          if (this.idInput) { this.idInput.disabled = false; this.idInput.value = v.id; }
          this.renderPrice(v);
          var dimsEl = this.querySelector('[data-selected-dimensions]');
          var dimsData = this.querySelector('[data-variant-dimensions]');
          if (dimsEl && dimsData) {
            try { var dimensions = JSON.parse(dimsData.textContent || '{}')[String(v.id)]; dimsEl.textContent = dimensions ? 'Selected: ' + dimensions : ''; dimsEl.hidden = !dimensions; } catch(e) { dimsEl.hidden = true; }
          }
          var dynamic = this.querySelector('.xp-pdp__dynamic');
          if (dynamic) dynamic.hidden = !v.available;
          this.setAtc(this.pending ? 'adding' : this.stateFor(v));
          this.querySelectorAll('.xp-offer__apply').forEach(function (a) {
            var offer = new URL(a.href);
            var destination = new URL(window.location.href);
            destination.searchParams.set('variant', v.id);
            offer.searchParams.set('redirect', destination.pathname + destination.search);
            a.href = offer.href;
          });
          if (this.barVariant) this.barVariant.textContent = v.label ? '· ' + v.options.map((value, index) => {
            const button = this.querySelectorAll('[data-option]')[index]?.querySelectorAll('[data-value]');
            return Array.from(button || []).find(b => b.dataset.value === value)?.dataset.label || value;
          }).join(' · ') : '';
          if (typeof v.media === 'number') this.show(v.media);
          if (this.variants.length > 1 && window.history && window.history.replaceState) {
            try {
              var u = new URL(window.location.href);
              u.searchParams.set('variant', v.id);
              window.history.replaceState(window.history.state, '', u.toString());
            } catch (err) {
              /* 老浏览器没有 URL：不更新地址栏 */
            }
          }
        }

        stateFor(v) {
          if (!v) return 'unavailable';
          return v.available ? (v.preorder ? 'preorder' : 'add') : 'sold_out';
        }

        renderPrice(v) {
          var span = document.createElement('span');
          span.className = 'xp-price';
          span.textContent = v.price_html;
          if (v.compare_html) {
            var s = document.createElement('s');
            s.className = 'xp-price__compare';
            s.textContent = v.compare_html;
            span.appendChild(document.createTextNode(' '));
            span.appendChild(s);
          }
          if (this.priceEl) {
            this.priceEl.textContent = '';
            this.priceEl.appendChild(span);
          }
          if (this.barPrice) this.barPrice.textContent = v.price_html;
        }

        /* 选项三态（审计 #1 BLOCKER）：
             is-unavailable = 这个值在任何组合下都买不到（划掉）
             is-conflict    = 值本身有货，只是跟当前另一个选项配不出变体（虚线，照样能点）
             当前选中的那颗两个都不打 —— 原来客户刚点 Matte Black，自己刚选的 18" 反而被划掉，
             加上价格还停在上一个变体，最合理的解读就是"这款没货了"，直接走人。 */
        markAvailability(sel) {
          var variants = this.variants;
          var tConflict = this.dataset.tConflict || '';
          var tSold = this.dataset.tSoldOut || '';
          this.groups.forEach(function (group, gi) {
            Array.prototype.forEach.call(group.querySelectorAll('button[data-value]'), function (b) {
              var val = b.dataset.value;
              var pressed = b.getAttribute('aria-pressed') === 'true';
              var sellable = variants.some(function (v) {
                return v.available && v.options[gi] === val;
              });
              var fits = variants.some(function (v) {
                if (!v.available || v.options[gi] !== val) return false;
                for (var gj = 0; gj < sel.length; gj++) {
                  if (gj !== gi && sel[gj] !== null && v.options[gj] !== sel[gj]) return false;
                }
                return true;
              });
              var dead = !sellable;
              var clash = sellable && !fits && !pressed;
              b.classList.toggle('is-unavailable', dead);
              b.classList.toggle('is-conflict', clash);

              /* 划线 / 虚线读屏看不见，状态要进可访问名。
                 色板是空按钮、名字全靠 aria-label，改 aria-label；
                 尺寸 / 胶囊按钮有可见文字，补一个 visually-hidden 尾巴，
                 别用 aria-label 盖掉按钮上那行尺寸。 */
              var note = dead ? tSold : clash ? tConflict : '';
              if (b.classList.contains('xp-swatch')) {
                b.setAttribute('aria-label', note ? val + ' — ' + note : val);
              } else {
                var tail = b.querySelector('[data-state-note]');
                if (note) {
                  if (!tail) {
                    tail = document.createElement('span');
                    tail.className = 'visually-hidden';
                    tail.setAttribute('data-state-note', '');
                    b.appendChild(tail);
                  }
                  tail.textContent = ' — ' + note;
                } else if (tail) {
                  tail.parentNode.removeChild(tail);
                }
              }
            });
          });
        }

        /* 组合配不出变体时说人话 + 给一条出路（审计 #1）：
           以客户刚点的那个值为锚点，挑一个"改动最少、同分最便宜"的可售组合；
           价格换成该锚点的最低可售价，绝不停在上一个变体的价上。 */
        showCombo(sel) {
          var box = this.comboBox;
          if (!box) return;
          var gi = typeof this.lastPick === 'number' && this.lastPick >= 0 ? this.lastPick : -1;
          var anchor = gi >= 0 ? sel[gi] : null;
          var pool = [];
          var i, j, v;
          for (i = 0; i < this.variants.length; i++) {
            v = this.variants[i];
            if (!v.available) continue;
            if (anchor !== null && v.options[gi] !== anchor) continue;
            pool.push(v);
          }
          /* 锚点值本身全店都没货：退回"全店可售"找建议，文案也退回通用版 */
          if (!pool.length && anchor !== null) {
            for (i = 0; i < this.variants.length; i++) {
              if (this.variants[i].available) pool.push(this.variants[i]);
            }
            anchor = null;
            gi = -1;
          }
          var best = null;
          var bestScore = -1;
          var minV = null;
          for (i = 0; i < pool.length; i++) {
            v = pool[i];
            var diff = 0;
            for (j = 0; j < sel.length; j++) {
              if (sel[j] !== null && v.options[j] !== sel[j]) diff++;
            }
            var score = diff * 100000000 + v.price;
            if (bestScore < 0 || score < bestScore) {
              bestScore = score;
              best = v;
            }
            if (!minV || v.price < minV.price) minV = v;
          }
          if (minV) {
            var from = (this.dataset.tFrom || '~PRICE~').replace('~PRICE~', function () {
              return minV.price_html;
            });
            if (this.priceEl) {
              /* 跟 renderPrice 保持同一个结构：外面那层 <p class="xp-pdp__price">，
                 里面永远是一个 span.xp-price，别把价格样式给弄没了 */
              var pspan = document.createElement('span');
              pspan.className = 'xp-price';
              pspan.textContent = from;
              this.priceEl.textContent = '';
              this.priceEl.appendChild(pspan);
            }
            if (this.barPrice) this.barPrice.textContent = from;
          }
          var text;
          if (anchor !== null) {
            var others = [];
            for (j = 0; j < sel.length; j++) {
              if (j !== gi && sel[j]) others.push(sel[j]);
            }
            text = (this.dataset.tCombo || '{value} is not available in {options}.')
              .replace('{value}', function () {
                return anchor;
              })
              .replace('{options}', function () {
                return others.join(' · ');
              });
          } else {
            text = this.dataset.tComboAny || 'That combination is not available.';
          }
          if (this.comboText) this.comboText.textContent = text;
          this.suggestion = best;
          if (this.comboFix) {
            if (best) {
              var changed = [];
              for (j = 0; j < sel.length; j++) {
                if (j !== gi && sel[j] !== null && best.options[j] !== sel[j]) changed.push(best.options[j]);
              }
              if (!changed.length) changed = best.options.slice();
              var label = (this.dataset.tSwitch || 'Switch to {options}').replace('{options}', function () {
                return changed.join(' · ');
              });
              this.comboFix.textContent = label + ' — ' + best.price_html;
              this.comboFix.hidden = false;
            } else {
              this.comboFix.hidden = true;
            }
          }
          box.hidden = false;
        }

        hideCombo() {
          this.suggestion = null;
          if (this.comboBox) this.comboBox.hidden = true;
          if (this.comboFix) this.comboFix.hidden = true;
        }

        /* 一键切到建议的可售组合（审计 #1 里那颗 "Switch to 36" – 13 Lights" 按钮） */
        selectVariant(v) {
          if (!v) return;
          this.groups.forEach(function (g, gi) {
            var val = v.options[gi];
            Array.prototype.forEach.call(g.querySelectorAll('button[data-value]'), function (b) {
              b.setAttribute('aria-pressed', b.dataset.value === val ? 'true' : 'false');
            });
            var lab = g.querySelector('[data-option-value]');
            if (lab) lab.textContent = val;
          });
          this.lastPick = -1;
          var sel = this.selected();
          this.apply(v, sel);
          this.markAvailability(sel);
          /* 按钮自己会被隐藏，焦点不能掉到 body 上；preventScroll 避免手机上跳一下 */
          if (this.atc && this.atc.focus) {
            try {
              this.atc.focus({ preventScroll: true });
            } catch (err) {
              this.atc.focus();
            }
          }
        }

        /* ---------- 加购按钮状态 ---------- */
        setAtc(state) {
          var t = this.dataset;
          var label = t.tAdd;
          var disabled = false;
          if (state === 'adding') {
            label = t.tAdding;
            disabled = true;
          } else if (state === 'added') {
            label = t.tAdded;
            disabled = true;
          } else if (state === 'preorder') {
            label = t.tPreorder;
          } else if (state === 'sold_out') {
            label = t.tSoldOut;
            disabled = true;
          } else if (state === 'unavailable') {
            label = t.tUnavailable;
            disabled = true;
          }
          if (this.atcLabel) this.atcLabel.textContent = label;
          if (this.atc) this.atc.disabled = disabled;
          if (this.barBtn) {
            this.barBtn.textContent = label;
            this.barBtn.disabled = disabled;
          }
        }

        showMsg(text) {
          if (!this.msg) return;
          this.msg.textContent = text;
          this.msg.hidden = false;
        }

        hideMsg() {
          if (!this.msg) return;
          this.msg.textContent = '';
          this.msg.hidden = true;
        }

        /* ---------- 图库 ---------- */
        _onThumbScroll(dir) {
          var strip = this.thumbStrip;
          if (!strip) return;
          var one = strip.querySelector('[data-thumb]');
          var step = one ? one.getBoundingClientRect().width + 10 : 90;
          // 尊重 prefers-reduced-motion：平滑滚动是动效，关了动效就直接跳过去
          var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          strip.scrollBy({ left: step * 3 * dir, behavior: reduced ? 'auto' : 'smooth' });
        }

        /* 左右按钮只在缩略图条真的滚得动时出现，并在滚到头时禁用那一侧。
           原来按"图片数 > 4"出按钮，实测 5/6/7 张图在 1440 宽下一排就放得下，
           按钮点了纹丝不动（Jack：多图片的左右选择不了）。 */
        syncThumbNav() {
          var strip = this.thumbStrip;
          var wrap = this.thumbWrap;
          if (!strip || !wrap) return;
          var overflow = strip.scrollWidth > strip.clientWidth + 2;
          wrap.classList.toggle('has-overflow', overflow);
          var max = strip.scrollWidth - strip.clientWidth;
          var x = strip.scrollLeft;
          var prev = wrap.querySelector('[data-thumb-scroll="-1"]');
          var next = wrap.querySelector('[data-thumb-scroll="1"]');
          var atStart = !overflow || x <= 1;
          var atEnd = !overflow || x >= max - 1;
          if (prev) prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
          if (next) next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
          /* 两侧渐隐跟着走（审计 #33）：滚到头那一侧的渐隐收掉，不然像还有内容 */
          wrap.classList.toggle('at-start', atStart);
          wrap.classList.toggle('at-end', atEnd);
        }

        /* 审计 #48：换 Finish 后主图对了，但选中的缩略图还在视口外（实测在 x=428–500，
           375 屏根本看不到），看上去像缩略图跟颜色没关系。
           用 strip.scrollTo 而不是 thumb.scrollIntoView —— 后者会把整个页面也纵向滚一下。 */
        scrollThumbIntoView(i) {
          var strip = this.thumbStrip;
          var t = this.thumbs[i];
          if (!strip || !t) return;
          if (strip.scrollWidth <= strip.clientWidth + 2) return;
          var sr = strip.getBoundingClientRect();
          var tr = t.getBoundingClientRect();
          if (tr.left >= sr.left - 1 && tr.right <= sr.right + 1) return; /* 已经在视野里，别乱动 */
          var delta = tr.left - sr.left - (sr.width - tr.width) / 2;
          var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (strip.scrollTo) {
            strip.scrollTo({ left: strip.scrollLeft + delta, behavior: reduced ? 'auto' : 'smooth' });
          } else {
            strip.scrollLeft = strip.scrollLeft + delta;
          }
        }

        /* 空闲时把当前图前后各一张先取回来（审计 #11）：滑到相邻那张时已经有像素了 */
        _idlePrefetch() {
          var self = this;
          var run = function () {
            var i = self.currentIndex || 0;
            self.hydrate(i + 1);
            self.hydrate(i - 1);
          };
          if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 2000 });
          else setTimeout(run, 1200);
        }

        _onPrefetch(e) {
          var t = e.target.closest && e.target.closest('[data-thumb]');
          if (t) this.hydrate(parseInt(t.dataset.index, 10));
        }

        hydrate(i) {
          var im = this.imgs[i];
          if (!im || !im.dataset.src) return;
          im.srcset = im.dataset.srcset || '';
          im.src = im.dataset.src;
          delete im.dataset.src;
          delete im.dataset.srcset;
        }

        show(i) {
          if (!this.imgs.length || i < 0 || i >= this.imgs.length) return;
          var self = this;
          var im = this.imgs[i];
          this.hydrate(i);
          this.currentIndex = i;
          this.thumbs.forEach(function (t, k) {
            t.setAttribute('aria-current', k === i ? 'true' : 'false');
          });
          this.scrollThumbIntoView(i);
          if (this.imgCounter) this.imgCounter.textContent = i + 1;
          if (this.barImg && this.thumbs[i]) {
            var t = this.thumbs[i].querySelector('img');
            if (t) {
              this.barImg.removeAttribute('srcset');
              this.barImg.removeAttribute('sizes');
              this.barImg.src = t.currentSrc || t.src;
            }
          }
          /* 审计 #11：原来点下去立刻把旧图淡出、新图那会儿一个像素都没有，
             430–500ms 之间屏幕上是纯灰块（本机直连 LAX 的成绩，4G 只会更长）。
             改成"新图 load 完才切 is-current"，没到位就一直留着旧图 —— 宁可晚半秒也不给空白。 */
          var swap = function () {
            if (self.currentIndex !== i) return; /* 期间又点了别的，这次作废 */
            self.imgs.forEach(function (m, k) {
              m.classList.toggle('is-current', k === i);
            });
            self._idlePrefetch();
          };
          if (im.complete && im.naturalWidth > 0) {
            swap();
          } else {
            im.addEventListener('load', swap, { once: true });
            im.addEventListener('error', swap, { once: true });
            /* 兜底：3s 还没 load（图挂了 / 网络卡死）也切过去，别永远停在旧图 */
            clearTimeout(this._imgTimer);
            this._imgTimer = setTimeout(swap, 3000);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  // 排序下拉：改了就提交（无 JS 时 noscript 里有按钮）
  document.querySelectorAll('.xp-search-page__sort[data-auto-submit]').forEach(function (form) {
    var select = form.querySelector('select');
    if (select) select.addEventListener('change', function () { form.submit(); });
  });

  } catch(e) { console.error(e); }
})();
})();
